import { useNavigate } from "react-router-dom";
import { AlertTriangle, Hand, CalendarClock, Truck } from "lucide-react";
import { numRef } from "@/lib/constants";
import { ContactarFornecedor } from "@/components/ContactarFornecedor";
import { fmtDia } from "@/components/PrazoLinha";
import { OrigemTag } from "@/components/FornTag";

const GRUPOS = [
  { key: "recolher_hoje", label: "Recolher hoje", Icon: Hand, cor: "orange" },
  { key: "atrasadas", label: "Recolhas atrasadas", Icon: AlertTriangle, cor: "rose", contactar: true },
  { key: "transportadora_atraso", label: "Transportadora: devia ter chegado", Icon: Truck, cor: "amber", contactar: true },
  { key: "chegam_amanha", label: "Chegam no próximo dia útil", Icon: CalendarClock, cor: "sky" },
];
const CORES = {
  orange: "bg-orange-50 border-orange-200 hover:border-orange-400",
  rose: "bg-rose-50 border-rose-200 hover:border-rose-400",
  amber: "bg-amber-50 border-amber-200 hover:border-amber-400",
  sky: "bg-sky-50 border-sky-200 hover:border-sky-400",
};

const Texto = ({ g, k }) => {
  const forn = g.fornecedor ? { nome: g.fornecedor, codigo_interno: g.fornecedor_codigo } : null;
  const onde = forn || g.origem ? <OrigemTag forn={forn} origem={{ nome: g.origem, codigo: g.origem_codigo }} /> : "—";
  if (k === "recolher_hoje") return <><b>{onde}</b> — {g.chegou ? "já chegou" : "prevista hoje"}, {g.linhas.length} linha(s)</>;
  if (k === "chegam_amanha") return <><b>{onde}</b> — {g.linhas.length} linha(s){g.recolha ? " a recolher" : ""}</>;
  return <><b>{onde}</b> — prevista {fmtDia(g.data_prevista)} (<b>{g.dias_atraso} dia(s)</b> de atraso), {g.linhas.length} linha(s)</>;
};

export const CopilotChegadas = ({ previsoes }) => {
  const navigate = useNavigate();
  return GRUPOS.filter((G) => previsoes?.[G.key]?.length).map((G) => (
    <div key={G.key} data-testid={`copilot-group-${G.key}`}>
      <div className="text-[10px] font-semibold uppercase text-slate-400 mb-1.5 flex items-center gap-1"><G.Icon size={11} /> {G.label}</div>
      <div className="space-y-1">
        {previsoes[G.key].map((g) => (
          <div key={g.encomenda_id} className="flex items-stretch gap-1">
            <button onClick={() => navigate(`/encomendas?enc=${g.numero}`)} title={g.linhas.join("\n")} data-testid={`copilot-${G.key}-${g.numero}`}
              className={`flex-1 min-w-0 text-left text-xs border rounded-md p-2 transition-colors ${CORES[G.cor]}`}>
              <span className="font-semibold">{numRef(g.numero, g.codigo)}</span> · <Texto g={g} k={G.key} />
            </button>
            {G.contactar && <ContactarFornecedor enc={g} />}
          </div>
        ))}
      </div>
    </div>
  ));
};

export const totalChegadas = (p) => GRUPOS.reduce((s, G) => s + (p?.[G.key]?.length || 0), 0);
